import { useState } from 'react';
import { LoadingIndicator } from '../common/components/loading-indicator';
import { FrCreateOrEditEventFormBody } from './fr-create-or-edit-event-form-body';
import { FrCreateOrEditEventHeader } from './fr-create-or-edit-event-header';
import { FrCreateOrEditEventFooter } from './fr-create-or-edit-event-footer';
import { FrPage } from '../fr-page-layout/fr-page';
import { useLocation } from 'react-router-dom';
import { useIntegratedForm } from '../forms/use-integrated-form';
import { FR_EDIT_EVENT_SUB_PATH } from '../router/constants';

export function FrCreateOrEditEventPage() {
    const [userManuallyAddedVehicleField, setUserManuallyAddedVehicleField] = useState(false);
    const [userManuallyAddedPersonField, setUserManuallyAddedPersonField] = useState(false);
    const location = useLocation();
    const { query: eventQuery } = useIntegratedForm();

    if (location.pathname.includes(FR_EDIT_EVENT_SUB_PATH) && eventQuery.isFetching) {
        return <LoadingIndicator />;
    }

    return (
        <FrPage>
            <FrCreateOrEditEventHeader />
            <FrCreateOrEditEventFormBody
                userManuallyAddedVehicleField={userManuallyAddedVehicleField}
                userManuallyAddedPersonField={userManuallyAddedPersonField}
            />
            <FrCreateOrEditEventFooter
                setUserManuallyAddedVehicleField={setUserManuallyAddedVehicleField}
                setUserManuallyAddedPersonField={setUserManuallyAddedPersonField}
            />
        </FrPage>
    );
}
